import React, { useState, useRef } from 'react';
import './OTPInput.css';

const OTPInput = ({ length = 6, onChangeOTP }) => {
  const [otp, setOTP] = useState(new Array(length).fill(''));
  const inputsRef = useRef([]);

  const handleChange = (element, index) => {
    // Sadece rakam girişi kontrolü (isteğe bağlı)
    if (element.value && !/^[0-9]$/.test(element.value)) return;
    
    const newOTP = [...otp];
    newOTP[index] = element.value;
    setOTP(newOTP);
    // Girilen karakter geçerliyse bir sonraki input’a geçiş yap
    if (element.value && index < length - 1) {
      inputsRef.current[index + 1].focus();
    }
    
    // OTP değerini dışarıya aktar
    if (onChangeOTP) onChangeOTP(newOTP);
  };

  const handleKeyDown = (e, index) => {
    // Backspace tuşu ile boş input ise bir önceki inputa geçiş
    if (e.key === 'Backspace' && otp[index] === '' && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  // Yapıştırma: herhangi bir kutuya kod yapıştırılınca rakamlar kutulara dağıtılır
  // (kutu-başına-tek-karakter olduğu için tek kutuya sığmıyordu). Yapıştırılan index'ten başlar.
  const handlePaste = (e, index) => {
    const pasted = (e.clipboardData || window.clipboardData)?.getData('text') || '';
    const digits = pasted.replace(/\D/g, '');
    if (!digits) return;
    e.preventDefault();
    const newOTP = [...otp];
    let i = index;
    for (const ch of digits) {
      if (i >= length) break;
      newOTP[i] = ch;
      i += 1;
    }
    setOTP(newOTP);
    if (onChangeOTP) onChangeOTP(newOTP);
    const focusIndex = Math.min(i, length - 1);
    const el = inputsRef.current[focusIndex];
    if (el) el.focus();
  };

  return (
    <div className="otp-input-container">
      {otp.map((data, index) => (
        <input
          type="text"
          name="otp"
          maxLength="1"
          key={index}
          value={data}
          onChange={(e) => handleChange(e.target, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={(e) => handlePaste(e, index)}
          ref={(el) => (inputsRef.current[index] = el)}
          className="otp-input"
        />
      ))}
    </div>
  );
};

export default OTPInput;
